import React, { useState, useEffect } from "react";

import {
    MdContentCopy,
} from "react-icons/all";


import { toast } from "react-toastify";



export default function CopyAndShortFormer({ value }) {

    return (

        <div>{`${value.substring(0, 6)}...${value.substring(value.length - 6)}`}
            <i className="ms-2" style={{ cursor: 'pointer' }} onClick={() => {
                navigator.clipboard.writeText(
                    value
                );
                toast.success("copied");
            }} >
                <MdContentCopy />
            </i>
        </div>
    );
}




